import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import IdeaCard from "@/components/ideas/IdeaCard";
import { Lightbulb, ArrowRight } from "lucide-react";

const HomeIdeasStrip = () => {
  const { data: ideas = [], isLoading } = useQuery({
    queryKey: ["home-ideas-strip"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("ideas")
        .select("*")
        .eq("status", "published")
        .not("title", "ilike", "%emerging market%")
        .order("vote_count", { ascending: false })
        .limit(9);
      if (error) throw error;

      const userIds = [...new Set((data || []).map((i: any) => i.user_id))];
      const { data: profiles } = await supabase
        .from("profiles")
        .select("user_id, display_name, avatar_url")
        .in("user_id", userIds);
      const map = new Map((profiles || []).map((p: any) => [p.user_id, p]));
      return (data || []).map((i: any) => ({ ...i, profiles: map.get(i.user_id) || null }));
    },
  });

  return (
    <section className="py-16 bg-background">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-3 mb-8">
          <div>
            <div className="flex items-center gap-2 text-primary mb-2">
              <Lightbulb className="h-5 w-5" />
              <span className="text-xs uppercase tracking-wider font-semibold">The Board</span>
            </div>
            <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground">
              Actionable Ideas
            </h2>
            <p className="text-muted-foreground mt-1 max-w-xl">
              What shareholders are signaling, building, and pushing forward.
            </p>
          </div>
          <a
            href="/ideas"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline"
          >
            Browse the full board <ArrowRight className="h-4 w-4" />
          </a>
        </div>

        {isLoading ? (
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-4">
            {Array.from({ length: 6 }).map((_, i) => (
              <div
                key={i}
                className="bg-card border border-border rounded-xl h-56 mb-4 animate-pulse break-inside-avoid"
              />
            ))}
          </div>
        ) : ideas.length === 0 ? (
          <div className="text-center py-12 bg-card border border-dashed border-border rounded-xl">
            <p className="text-muted-foreground">
              The board is still warming up. <a href="/ideas" className="text-primary underline">Be the first to share an idea</a>.
            </p>
          </div>
        ) : (
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-4">
            {ideas.map((idea: any) => (
              <IdeaCard
                key={idea.id}
                idea={idea}
                hasVoted={false}
                onVote={() => {}}
                currentUserId={null}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default HomeIdeasStrip;